import { ErrorView } from "@/components/ErrorView";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { useRouter } from "@tanstack/react-router";

// Replaces TanStack Router's default "Something went wrong! Hide Error" fallback.
// Wired via `defaultErrorComponent` on the router — per-route `errorComponent`
// overrides still take precedence. The actual UI lives in ErrorView so the
// same look is shared with page-level + inline error sites across the app.
export function RouteErrorBoundary({
  error,
  reset,
}: {
  error: unknown;
  reset?: () => void;
}) {
  useDocumentTitle("Something went wrong");
  const router = useRouter();
  return (
    <ErrorView
      variant="fullscreen"
      title="Something broke on this page."
      error={error}
      showHome
      onRetry={() => {
        reset?.();
        router.invalidate();
      }}
    />
  );
}
